export default __webpack_public_path__ + "static/plasticbank-icons-49deee3665e39a89678c3d0564f9eba7.svg";